import { ActionInfo, defaultAction } from "./ActionInfoTypes";

// Collect Actions
import { Collect_3005 } from "./CollectActions";

// Create Actions
import {
  Create_3004,
  Create_3010,
  Create_3003,
  Create_3001,
} from "./CreateActions";

// Split Actions
import {
  Split_3005,
  Split_3004,
  Split_3010,
  Split_3003,
  Split_3001,
} from "./SplitActions";

// AutoCollect Actions
import {
  AutoCollect_3005,
  AutoCollect_3004,
  AutoCollect_3010,
  AutoCollect_3003,
  AutoCollect_3001,
  AutoCollect_3024,
  AutoCollect_3023,
  AutoCollect_3710,
  AutoCollect_3022,
  AutoCollect_3020,
  AutoCollect_3005_10,
  AutoCollect_3004_10,
  AutoCollect_3024_10,
  AutoCollect_3023_10,
  AutoCollect_3010_10,
  AutoCollect_3003_10,
  AutoCollect_3001_10,
  AutoCollect_3710_10,
  AutoCollect_3022_10,
  AutoCollect_3020_10,
  AutoCollect_3005_75,
  AutoCollect_3004_75,
  AutoCollect_3024_75,
  AutoCollect_3023_75,
  AutoCollect_3010_75,
  AutoCollect_3003_75,
  AutoCollect_3001_75,
  AutoCollect_3710_75,
  AutoCollect_3022_75,
  AutoCollect_3020_75,
  AutoCollect_3005_250,
  AutoCollect_3004_250,
  AutoCollect_3024_250,
  AutoCollect_3023_250,
  AutoCollect_3010_250,
  AutoCollect_3003_250,
  AutoCollect_3001_250,
  AutoCollect_3710_250,
  AutoCollect_3022_250,
  AutoCollect_3020_250,
  AutoCollect_BrickPack_SlopedBricksPartOne,
  AutoCollect_BrickPack_MinifigUtensilsPartOne,
  AutoCollect_BrickPack_BioniclesPartOne,
  AutoCollect_BrickPack_AnimalsPartOne,
  AutoCollect_BrickPack_MinifigUtensilsPartTwo,
  AutoCollect_BrickPack_BioniclesPartTwo,
  AutoCollect_BrickPack_CircularBricks,
  AutoCollect_BrickPack_MinifigHair,
  AutoCollect_BrickPack_TechnicBricks,
  AutoCollect_BrickPack_MinifigHeadgear,
  AutoCollect_BrickPack_SlopedBricksPartOne_15,
  AutoCollect_BrickPack_MinifigUtensilsPartOne_15,
  AutoCollect_BrickPack_BioniclesPartOne_15,
  AutoCollect_BrickPack_AnimalsPartOne_15,
  AutoCollect_BrickPack_MinifigUtensilsPartTwo_15,
  AutoCollect_BrickPack_BioniclesPartTwo_15,
  AutoCollect_BrickPack_CircularBricks_15,
  AutoCollect_BrickPack_MinifigHair_15,
  AutoCollect_BrickPack_TechnicBricks_15,
  AutoCollect_BrickPack_MinifigHeadgear_15,
  AutoCollect_BrickPack_SlopedBricksPartOne_75,
  AutoCollect_BrickPack_MinifigUtensilsPartOne_75,
  AutoCollect_BrickPack_BioniclesPartOne_75,
  AutoCollect_BrickPack_AnimalsPartOne_75,
  AutoCollect_BrickPack_MinifigUtensilsPartTwo_75,
  AutoCollect_BrickPack_BioniclesPartTwo_75,
} from "./AutoCollectActions";

// Capacity Actions
import {
  IncreaseCapacity_3005,
  IncreaseCapacity_3004,
  IncreaseCapacity_3010,
  IncreaseCapacity_3003,
  IncreaseCapacity_3001,
  IncreaseCapacity_3024,
  IncreaseCapacity_3023,
  IncreaseCapacity_3710,
  IncreaseCapacity_3022,
  IncreaseCapacity_3020,
  IncreaseCapacity_3005_100,
  IncreaseCapacity_3004_100,
  IncreaseCapacity_3024_100,
  IncreaseCapacity_3023_100,
  IncreaseCapacity_3010_100,
  IncreaseCapacity_3003_100,
  IncreaseCapacity_3001_100,
  IncreaseCapacity_3710_100,
  IncreaseCapacity_3022_100,
  IncreaseCapacity_3020_100,
  IncreaseCapacity_3005_350,
  IncreaseCapacity_3004_350,
  IncreaseCapacity_3024_350,
  IncreaseCapacity_3023_350,
  IncreaseCapacity_3010_350,
  IncreaseCapacity_3003_350,
  IncreaseCapacity_3001_350,
  IncreaseCapacity_3710_350,
  IncreaseCapacity_3022_350,
  IncreaseCapacity_3020_350,
  IncreaseCapacity_3005_1000,
  IncreaseCapacity_3004_1000,
  IncreaseCapacity_3024_1000,
  IncreaseCapacity_3023_1000,
  IncreaseCapacity_3010_1000,
  IncreaseCapacity_3003_1000,
  IncreaseCapacity_3001_1000,
  IncreaseCapacity_3710_1000,
  IncreaseCapacity_3022_1000,
  IncreaseCapacity_3020_1000,
  IncreaseCapacity_BrickPack_SlopedBricksPartOne,
  IncreaseCapacity_BrickPack_MinifigUtensilsPartOne,
  IncreaseCapacity_BrickPack_BioniclesPartOne,
  IncreaseCapacity_BrickPack_AnimalsPartOne,
  IncreaseCapacity_BrickPack_MinifigUtensilsPartTwo,
  IncreaseCapacity_BrickPack_BioniclesPartTwo,
  IncreaseCapacity_BrickPack_CircularBricks,
  IncreaseCapacity_BrickPack_MinifigHair,
  IncreaseCapacity_BrickPack_TechnicBricks,
  IncreaseCapacity_BrickPack_MinifigHeadgear,
  IncreaseCapacity_BrickPack_SlopedBricksPartOne_75,
  IncreaseCapacity_BrickPack_MinifigUtensilsPartOne_75,
  IncreaseCapacity_BrickPack_BioniclesPartOne_75,
  IncreaseCapacity_BrickPack_AnimalsPartOne_75,
  IncreaseCapacity_BrickPack_MinifigUtensilsPartTwo_75,
  IncreaseCapacity_BrickPack_BioniclesPartTwo_75,
  IncreaseCapacity_BrickPack_CircularBricks_75,
  IncreaseCapacity_BrickPack_MinifigHair_75,
  IncreaseCapacity_BrickPack_TechnicBricks_75,
  IncreaseCapacity_BrickPack_MinifigHeadgear_75,
} from "./CapacityActions";

// BrickPack Actions
import {
  BrickPack_SlopedBricksPartOne,
  BrickPack_MinifigUtensilsPartOne,
  BrickPack_BioniclesPartOne,
  BrickPack_AnimalsPartOne,
  BrickPack_MinifigUtensilsPartTwo,
  BrickPack_BioniclesPartTwo,
  BrickPack_CircularBricks,
  BrickPack_MinifigHair,
  BrickPack_TechnicBricks,
  BrickPack_MinifigHeadgear,
} from "./BrickPackActions";

// Upgrade Actions
import {
  Upgrade_BrickPack_SlopedBricksPartOne,
  Upgrade_BrickPack_MinifigUtensilsPartOne,
  Upgrade_BrickPack_BioniclesPartOne,
  Upgrade_BrickPack_AnimalsPartOne,
  Upgrade_BrickPack_MinifigUtensilsPartTwo,
  Upgrade_BrickPack_BioniclesPartTwo,
  Upgrade_BrickPack_CircularBricks,
  Upgrade_BrickPack_MinifigHair,
  Upgrade_BrickPack_TechnicBricks,
  Upgrade_BrickPack_MinifigHeadgear,
} from "./UpgradeActions";

// Set Actions
import {
  BuySet_AlphaTeamCruiser,
  BuySet_Tahu,
  BuySet_TheKnightBus,
  BuySet_EiffelTower,
  BuySet_GarbageTruck,
  BuySet_HimejiCastle,
  BuySet_TIEFighter,
  BuySet_LloydsLegendaryDragon,
  BuySet_LionKnightsCastle,
  BuySet_MillenniumFalcon,
} from "./SetActions";

// -----
// *** These values should never be changed by player ***
// -----
export const ActionInfoTotal: Map<string, ActionInfo> = new Map([
  [defaultAction.id, defaultAction],
  [Collect_3005.id, Collect_3005],
  [Create_3004.id, Create_3004],
  [Split_3005.id, Split_3005],
  [Split_3004.id, Split_3004],
  [AutoCollect_3005.id, AutoCollect_3005],
  [AutoCollect_3004.id, AutoCollect_3004],
  [AutoCollect_3024.id, AutoCollect_3024],
  [AutoCollect_3023.id, AutoCollect_3023],
  [IncreaseCapacity_3005.id, IncreaseCapacity_3005],
  [IncreaseCapacity_3004.id, IncreaseCapacity_3004],
  [IncreaseCapacity_3024.id, IncreaseCapacity_3024],
  [IncreaseCapacity_3023.id, IncreaseCapacity_3023],
  [Create_3010.id, Create_3010],
  [AutoCollect_3010.id, AutoCollect_3010],
  [IncreaseCapacity_3010.id, IncreaseCapacity_3010],
  [Create_3003.id, Create_3003],
  [AutoCollect_3003.id, AutoCollect_3003],
  [IncreaseCapacity_3003.id, IncreaseCapacity_3003],
  [Create_3001.id, Create_3001],
  [AutoCollect_3001.id, AutoCollect_3001],
  [IncreaseCapacity_3001.id, IncreaseCapacity_3001],
  [Split_3010.id, Split_3010],
  [AutoCollect_3710.id, AutoCollect_3710],
  [IncreaseCapacity_3710.id, IncreaseCapacity_3710],
  [Split_3003.id, Split_3003],
  [AutoCollect_3022.id, AutoCollect_3022],
  [IncreaseCapacity_3022.id, IncreaseCapacity_3022],
  [Split_3001.id, Split_3001],
  [AutoCollect_3020.id, AutoCollect_3020],
  [IncreaseCapacity_3020.id, IncreaseCapacity_3020],
  [AutoCollect_3005_10.id, AutoCollect_3005_10],
  [AutoCollect_3004_10.id, AutoCollect_3004_10],
  [AutoCollect_3024_10.id, AutoCollect_3024_10],
  [AutoCollect_3023_10.id, AutoCollect_3023_10],
  [AutoCollect_3010_10.id, AutoCollect_3010_10],
  [AutoCollect_3003_10.id, AutoCollect_3003_10],
  [AutoCollect_3001_10.id, AutoCollect_3001_10],
  [AutoCollect_3710_10.id, AutoCollect_3710_10],
  [AutoCollect_3022_10.id, AutoCollect_3022_10],
  [AutoCollect_3020_10.id, AutoCollect_3020_10],
  [IncreaseCapacity_3005_100.id, IncreaseCapacity_3005_100],
  [IncreaseCapacity_3004_100.id, IncreaseCapacity_3004_100],
  [IncreaseCapacity_3024_100.id, IncreaseCapacity_3024_100],
  [IncreaseCapacity_3023_100.id, IncreaseCapacity_3023_100],
  [IncreaseCapacity_3010_100.id, IncreaseCapacity_3010_100],
  [IncreaseCapacity_3003_100.id, IncreaseCapacity_3003_100],
  [IncreaseCapacity_3001_100.id, IncreaseCapacity_3001_100],
  [IncreaseCapacity_3710_100.id, IncreaseCapacity_3710_100],
  [IncreaseCapacity_3022_100.id, IncreaseCapacity_3022_100],
  [IncreaseCapacity_3020_100.id, IncreaseCapacity_3020_100],
  [AutoCollect_3005_75.id, AutoCollect_3005_75],
  [AutoCollect_3004_75.id, AutoCollect_3004_75],
  [AutoCollect_3024_75.id, AutoCollect_3024_75],
  [AutoCollect_3023_75.id, AutoCollect_3023_75],
  [AutoCollect_3010_75.id, AutoCollect_3010_75],
  [AutoCollect_3003_75.id, AutoCollect_3003_75],
  [AutoCollect_3001_75.id, AutoCollect_3001_75],
  [AutoCollect_3710_75.id, AutoCollect_3710_75],
  [AutoCollect_3022_75.id, AutoCollect_3022_75],
  [AutoCollect_3020_75.id, AutoCollect_3020_75],
  [IncreaseCapacity_3005_350.id, IncreaseCapacity_3005_350],
  [IncreaseCapacity_3004_350.id, IncreaseCapacity_3004_350],
  [IncreaseCapacity_3024_350.id, IncreaseCapacity_3024_350],
  [IncreaseCapacity_3023_350.id, IncreaseCapacity_3023_350],
  [IncreaseCapacity_3010_350.id, IncreaseCapacity_3010_350],
  [IncreaseCapacity_3003_350.id, IncreaseCapacity_3003_350],
  [IncreaseCapacity_3001_350.id, IncreaseCapacity_3001_350],
  [IncreaseCapacity_3710_350.id, IncreaseCapacity_3710_350],
  [IncreaseCapacity_3022_350.id, IncreaseCapacity_3022_350],
  [IncreaseCapacity_3020_350.id, IncreaseCapacity_3020_350],
  [AutoCollect_3005_250.id, AutoCollect_3005_250],
  [AutoCollect_3004_250.id, AutoCollect_3004_250],
  [AutoCollect_3024_250.id, AutoCollect_3024_250],
  [AutoCollect_3023_250.id, AutoCollect_3023_250],
  [AutoCollect_3010_250.id, AutoCollect_3010_250],
  [AutoCollect_3003_250.id, AutoCollect_3003_250],
  [AutoCollect_3001_250.id, AutoCollect_3001_250],
  [AutoCollect_3710_250.id, AutoCollect_3710_250],
  [AutoCollect_3022_250.id, AutoCollect_3022_250],
  [AutoCollect_3020_250.id, AutoCollect_3020_250],
  [IncreaseCapacity_3005_1000.id, IncreaseCapacity_3005_1000],
  [IncreaseCapacity_3004_1000.id, IncreaseCapacity_3004_1000],
  [IncreaseCapacity_3024_1000.id, IncreaseCapacity_3024_1000],
  [IncreaseCapacity_3023_1000.id, IncreaseCapacity_3023_1000],
  [IncreaseCapacity_3010_1000.id, IncreaseCapacity_3010_1000],
  [IncreaseCapacity_3003_1000.id, IncreaseCapacity_3003_1000],
  [IncreaseCapacity_3001_1000.id, IncreaseCapacity_3001_1000],
  [IncreaseCapacity_3710_1000.id, IncreaseCapacity_3710_1000],
  [IncreaseCapacity_3022_1000.id, IncreaseCapacity_3022_1000],
  [IncreaseCapacity_3020_1000.id, IncreaseCapacity_3020_1000],

  //
  // Brickpacks
  //
  [BrickPack_SlopedBricksPartOne.id, BrickPack_SlopedBricksPartOne],
  [BrickPack_MinifigUtensilsPartOne.id, BrickPack_MinifigUtensilsPartOne],
  [BrickPack_BioniclesPartOne.id, BrickPack_BioniclesPartOne],
  [BrickPack_AnimalsPartOne.id, BrickPack_AnimalsPartOne],
  [BrickPack_MinifigUtensilsPartTwo.id, BrickPack_MinifigUtensilsPartTwo],
  [BrickPack_BioniclesPartTwo.id, BrickPack_BioniclesPartTwo],
  [BrickPack_CircularBricks.id, BrickPack_CircularBricks],
  [BrickPack_MinifigHair.id, BrickPack_MinifigHair],
  [BrickPack_TechnicBricks.id, BrickPack_TechnicBricks],
  [BrickPack_MinifigHeadgear.id, BrickPack_MinifigHeadgear],
  //
  // Upgrades
  //
  [
    Upgrade_BrickPack_SlopedBricksPartOne.id,
    Upgrade_BrickPack_SlopedBricksPartOne,
  ],
  [
    Upgrade_BrickPack_MinifigUtensilsPartOne.id,
    Upgrade_BrickPack_MinifigUtensilsPartOne,
  ],
  [Upgrade_BrickPack_BioniclesPartOne.id, Upgrade_BrickPack_BioniclesPartOne],
  [Upgrade_BrickPack_AnimalsPartOne.id, Upgrade_BrickPack_AnimalsPartOne],
  [
    Upgrade_BrickPack_MinifigUtensilsPartTwo.id,
    Upgrade_BrickPack_MinifigUtensilsPartTwo,
  ],
  [Upgrade_BrickPack_BioniclesPartTwo.id, Upgrade_BrickPack_BioniclesPartTwo],
  [Upgrade_BrickPack_CircularBricks.id, Upgrade_BrickPack_CircularBricks],
  [Upgrade_BrickPack_MinifigHair.id, Upgrade_BrickPack_MinifigHair],
  [Upgrade_BrickPack_TechnicBricks.id, Upgrade_BrickPack_TechnicBricks],
  [Upgrade_BrickPack_MinifigHeadgear.id, Upgrade_BrickPack_MinifigHeadgear],
  //
  // Capacity for Brick Packs
  //
  [
    IncreaseCapacity_BrickPack_SlopedBricksPartOne.id,
    IncreaseCapacity_BrickPack_SlopedBricksPartOne,
  ],
  [
    IncreaseCapacity_BrickPack_MinifigUtensilsPartOne.id,
    IncreaseCapacity_BrickPack_MinifigUtensilsPartOne,
  ],
  [
    IncreaseCapacity_BrickPack_BioniclesPartOne.id,
    IncreaseCapacity_BrickPack_BioniclesPartOne,
  ],
  [
    IncreaseCapacity_BrickPack_AnimalsPartOne.id,
    IncreaseCapacity_BrickPack_AnimalsPartOne,
  ],
  [
    IncreaseCapacity_BrickPack_MinifigUtensilsPartTwo.id,
    IncreaseCapacity_BrickPack_MinifigUtensilsPartTwo,
  ],
  [
    IncreaseCapacity_BrickPack_BioniclesPartTwo.id,
    IncreaseCapacity_BrickPack_BioniclesPartTwo,
  ],
  [
    IncreaseCapacity_BrickPack_CircularBricks.id,
    IncreaseCapacity_BrickPack_CircularBricks,
  ],
  [
    IncreaseCapacity_BrickPack_MinifigHair.id,
    IncreaseCapacity_BrickPack_MinifigHair,
  ],
  [
    IncreaseCapacity_BrickPack_TechnicBricks.id,
    IncreaseCapacity_BrickPack_TechnicBricks,
  ],
  [
    IncreaseCapacity_BrickPack_MinifigHeadgear.id,
    IncreaseCapacity_BrickPack_MinifigHeadgear,
  ],
  [
    IncreaseCapacity_BrickPack_SlopedBricksPartOne_75.id,
    IncreaseCapacity_BrickPack_SlopedBricksPartOne_75,
  ],
  [
    IncreaseCapacity_BrickPack_MinifigUtensilsPartOne_75.id,
    IncreaseCapacity_BrickPack_MinifigUtensilsPartOne_75,
  ],
  [
    IncreaseCapacity_BrickPack_BioniclesPartOne_75.id,
    IncreaseCapacity_BrickPack_BioniclesPartOne_75,
  ],
  [
    IncreaseCapacity_BrickPack_AnimalsPartOne_75.id,
    IncreaseCapacity_BrickPack_AnimalsPartOne_75,
  ],
  [
    IncreaseCapacity_BrickPack_MinifigUtensilsPartTwo_75.id,
    IncreaseCapacity_BrickPack_MinifigUtensilsPartTwo_75,
  ],
  [
    IncreaseCapacity_BrickPack_BioniclesPartTwo_75.id,
    IncreaseCapacity_BrickPack_BioniclesPartTwo_75,
  ],
  [
    IncreaseCapacity_BrickPack_CircularBricks_75.id,
    IncreaseCapacity_BrickPack_CircularBricks_75,
  ],
  [
    IncreaseCapacity_BrickPack_MinifigHair_75.id,
    IncreaseCapacity_BrickPack_MinifigHair_75,
  ],
  [
    IncreaseCapacity_BrickPack_TechnicBricks_75.id,
    IncreaseCapacity_BrickPack_TechnicBricks_75,
  ],
  [
    IncreaseCapacity_BrickPack_MinifigHeadgear_75.id,
    IncreaseCapacity_BrickPack_MinifigHeadgear_75,
  ],
  //
  // Auto Collect for Brick Packs
  //
  [
    AutoCollect_BrickPack_SlopedBricksPartOne.id,
    AutoCollect_BrickPack_SlopedBricksPartOne,
  ],
  [
    AutoCollect_BrickPack_MinifigUtensilsPartOne.id,
    AutoCollect_BrickPack_MinifigUtensilsPartOne,
  ],
  [
    AutoCollect_BrickPack_BioniclesPartOne.id,
    AutoCollect_BrickPack_BioniclesPartOne,
  ],
  [
    AutoCollect_BrickPack_AnimalsPartOne.id,
    AutoCollect_BrickPack_AnimalsPartOne,
  ],
  [
    AutoCollect_BrickPack_MinifigUtensilsPartTwo.id,
    AutoCollect_BrickPack_MinifigUtensilsPartTwo,
  ],
  [
    AutoCollect_BrickPack_BioniclesPartTwo.id,
    AutoCollect_BrickPack_BioniclesPartTwo,
  ],
  [
    AutoCollect_BrickPack_CircularBricks.id,
    AutoCollect_BrickPack_CircularBricks,
  ],
  [AutoCollect_BrickPack_MinifigHair.id, AutoCollect_BrickPack_MinifigHair],
  [AutoCollect_BrickPack_TechnicBricks.id, AutoCollect_BrickPack_TechnicBricks],
  [
    AutoCollect_BrickPack_MinifigHeadgear.id,
    AutoCollect_BrickPack_MinifigHeadgear,
  ],
  [
    AutoCollect_BrickPack_SlopedBricksPartOne_15.id,
    AutoCollect_BrickPack_SlopedBricksPartOne_15,
  ],
  [
    AutoCollect_BrickPack_MinifigUtensilsPartOne_15.id,
    AutoCollect_BrickPack_MinifigUtensilsPartOne_15,
  ],
  [
    AutoCollect_BrickPack_BioniclesPartOne_15.id,
    AutoCollect_BrickPack_BioniclesPartOne_15,
  ],
  [
    AutoCollect_BrickPack_AnimalsPartOne_15.id,
    AutoCollect_BrickPack_AnimalsPartOne_15,
  ],
  [
    AutoCollect_BrickPack_MinifigUtensilsPartTwo_15.id,
    AutoCollect_BrickPack_MinifigUtensilsPartTwo_15,
  ],
  [
    AutoCollect_BrickPack_BioniclesPartTwo_15.id,
    AutoCollect_BrickPack_BioniclesPartTwo_15,
  ],
  [
    AutoCollect_BrickPack_CircularBricks_15.id,
    AutoCollect_BrickPack_CircularBricks_15,
  ],
  [
    AutoCollect_BrickPack_MinifigHair_15.id,
    AutoCollect_BrickPack_MinifigHair_15,
  ],
  [
    AutoCollect_BrickPack_TechnicBricks_15.id,
    AutoCollect_BrickPack_TechnicBricks_15,
  ],
  [
    AutoCollect_BrickPack_MinifigHeadgear_15.id,
    AutoCollect_BrickPack_MinifigHeadgear_15,
  ],
  [
    AutoCollect_BrickPack_SlopedBricksPartOne_75.id,
    AutoCollect_BrickPack_SlopedBricksPartOne_75,
  ],
  [
    AutoCollect_BrickPack_MinifigUtensilsPartOne_75.id,
    AutoCollect_BrickPack_MinifigUtensilsPartOne_75,
  ],
  [
    AutoCollect_BrickPack_BioniclesPartOne_75.id,
    AutoCollect_BrickPack_BioniclesPartOne_75,
  ],
  [
    AutoCollect_BrickPack_AnimalsPartOne_75.id,
    AutoCollect_BrickPack_AnimalsPartOne_75,
  ],
  [
    AutoCollect_BrickPack_MinifigUtensilsPartTwo_75.id,
    AutoCollect_BrickPack_MinifigUtensilsPartTwo_75,
  ],
  [
    AutoCollect_BrickPack_BioniclesPartTwo_75.id,
    AutoCollect_BrickPack_BioniclesPartTwo_75,
  ],
  //
  // Sets
  //
  [BuySet_AlphaTeamCruiser.id, BuySet_AlphaTeamCruiser],
  [BuySet_Tahu.id, BuySet_Tahu],
  [BuySet_TheKnightBus.id, BuySet_TheKnightBus],
  [BuySet_GarbageTruck.id, BuySet_GarbageTruck],
  [BuySet_TIEFighter.id, BuySet_TIEFighter],
  [BuySet_LloydsLegendaryDragon.id, BuySet_LloydsLegendaryDragon],
  [BuySet_HimejiCastle.id, BuySet_HimejiCastle],
  [BuySet_LionKnightsCastle.id, BuySet_LionKnightsCastle],
  [BuySet_MillenniumFalcon.id, BuySet_MillenniumFalcon],
  [BuySet_EiffelTower.id, BuySet_EiffelTower],
]);
